import React, { useEffect } from 'react';

import { useHistory, useParams } from 'react-router-dom';
import { PageWrapper } from '../../containers/PageWrapper/PageWrapper';
import { Follower } from './shared/components/Follower';
import { FollowersHeader } from './shared/components/Header';
import { useUser } from '../../hooks/query/useUser';
import { useAuthContext } from '../../contexts/authContext';

interface QueryParams {
  username: string;
}

export const UserFollowers = () => {
  const history = useHistory();
  const { loggedInAccount } = useAuthContext();
  const { username } = useParams<QueryParams>();
  const { data: user, isSuccess: isUserSuccess } = useUser({ username });

  useEffect(() => {
    if (loggedInAccount?.username === username) {
      history.push('/account/followers');
    }
  }, [username]);

  const onAccessoryClick = () => history.push(`/users/${username}/following`);

  return (
    <PageWrapper>
      <FollowersHeader onAccessoryClick={onAccessoryClick} />
      {isUserSuccess &&
        user.followers.map(({ id, profileImage, name, username }) => (
          <Follower
            avatar={profileImage}
            name={name}
            username={username}
            key={id}
          />
        ))}
    </PageWrapper>
  );
};
